// ErrorLine / WarnLine — the one red line under a field or above a button,
// and its amber sibling for a warning that does not refuse.
//
// THE RULE IT ENFORCES (§7 rule 11): a guard refuses IN WORDS, before any
// write, naming the figures — "chain sent 24,703.55, trade says 24,678.85",
// "Pays and receives can't be the same account". One line, one place, one
// negative token (`text-neg`) and one warn token (`text-warn`) — not
// text-red-500, text-amber-500, text-tg-destructive and text-warn across
// screens. The colour underlines the words; the words carry the meaning.
//
// Renders nothing when there is nothing to say, so a screen can write
// `<ErrorLine>{problem}</ErrorLine>` with `problem: string | null`.
//
// `className` REPLACES the default margin rather than fighting it: the
// default is `mt-1` (the line under a field); a screen that places the line
// itself passes its own classes and gets exactly those — no "mt-0" to cancel
// a margin it never asked for (Phase C review, 14 Sept 2026).
//
// Usage:
//   <Field label="Rate" hint="AED per USDT · auto">
//     <input … />
//     <ErrorLine>{rateProblem(rate)}</ErrorLine>
//   </Field>
//   <WarnLine>More than the 1,250 AED balance — the box flips the other way by 50</WarnLine>

import type { ReactNode } from 'react';

function empty(children: ReactNode): boolean {
  return children === null || children === undefined || children === false || children === '';
}

export function ErrorLine({ children, className = 'mt-1' }: { children: ReactNode; className?: string }) {
  if (empty(children)) return null;
  return <p role="alert" className={`text-meta text-neg ${className}`}>{children}</p>;
}

export function WarnLine({ children, className = 'mt-1' }: { children: ReactNode; className?: string }) {
  if (empty(children)) return null;
  return <p className={`text-meta text-warn ${className}`}>{children}</p>;
}
